import classes from "./AuthPopupHelpButton.module.scss";

interface IProps {
  onClick: () => void;
  value: string;
}

export const AuthPopupHelpButton = ({ onClick, value }: IProps) => {
  return (
    <button
      type="button"
      className={classes.HelpButton}
      onClick={onClick}
    >
      {value}
    </button>
  );
};
